export const LAB_MOCK_DATA = {
  lab_id: "00000000-0000-0000-0000-000000000000",
  graphics: {
    l: [
      { id: 1,  nome: "Planejamento A", l: 120000 },
      { id: 2,  nome: "Planejamento B", l: 100000 },
      { id: 3,  nome: "Planejamento C", l: 160000 },
      { id: 4,  nome: "Planejamento D", l: 40000  },
      { id: 5,  nome: "Planejamento E", l: 70000  },
      { id: 6,  nome: "Planejamento F", l: 180000 },
      { id: 7,  nome: "Planejamento G", l: 160000 },
      { id: 8,  nome: "Planejamento H", l: 45000  },
      { id: 9,  nome: "Planejamento I", l: 90000  },
      { id: 10, nome: "Planejamento J", l: 42000  },
      { id: 11, nome: "Planejamento K", l: 140000 },
      { id: 12, nome: "Planejamento L", l: 135000 },
    ],
    lt: [
      { id: 1,  nome: "Planejamento A", lt: 32 },
      { id: 2,  nome: "Planejamento B", lt: 27 },
      { id: 3,  nome: "Planejamento C", lt: 44 },
      { id: 4,  nome: "Planejamento D", lt: 11 },
      { id: 5,  nome: "Planejamento E", lt: 19 },
      { id: 6,  nome: "Planejamento F", lt: 48 },
      { id: 7,  nome: "Planejamento G", lt: 43 },
      { id: 8,  nome: "Planejamento H", lt: 12 },
      { id: 9,  nome: "Planejamento I", lt: 24 },
      { id: 10, nome: "Planejamento J", lt: 11 },
      { id: 11, nome: "Planejamento K", lt: 38 },
      { id: 12, nome: "Planejamento L", lt: 36 },
    ],
  },
  movements: [],
};
